import { render, staticRenderFns } from "./ViewCoupon.vue?vue&type=template&id=b1774c1e"
import script from "./ViewCoupon.vue?vue&type=script&lang=js"
export * from "./ViewCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports